import _ from 'lodash';


function createMergeReportQueries(mergeReportConfig) {

  const allFields = [
    ...mergeReportConfig.selectedFields.primaryReport,
    ...mergeReportConfig.selectedFields.secondaryReport
  ];

  const dimensions = allFields
    .filter(field => field.keyType === 'dimension')
    .map(field => field.fieldName);

  const measures = allFields
    .filter(field => field.keyType === 'measure')
    .map(field => field.fieldName);


  return {
    measures,
    dimensions,
  };

}

function createMergeReportAnnotations(mergeReportConfig) {
    const annotation = {
      measures: {},
      dimensions: {},
      segments: {},
      timeDimensions: {}
    };

    mergeReportConfig?.selectedFields?.primaryReport?.forEach(field => {
      if (field.keyType === 'measure') {
        annotation.measures[field.fieldName] = {
          title: field?.displayName || field?.fieldName,
          shortTitle: field?.displayName || field?.fieldName?.split('.')[1],
          description: field?.displayName || field?.fieldName?.split('.')[1],
          type: "number",
          drillMembers: [],
          drillMembersGrouped: {
            measures: [],
            dimensions: []
          }
        };
      } else { // dimension
        annotation.dimensions[field.fieldName] = {
          title: field?.displayName || field?.fieldName,
          shortTitle: field?.displayName || field?.fieldName?.split('.')[1],
          description: field?.displayName || field?.fieldName?.split('.')[1],
          type: "string"
        };
      }
    });

    mergeReportConfig?.selectedFields?.secondaryReport?.forEach(field => {
      if (field.keyType === 'measure') {
        annotation.measures[field.fieldName] = {
          title: field?.displayName || field?.fieldName,
          shortTitle: field?.displayName || field?.fieldName?.split('.')[1],
          description: field?.displayName || field?.fieldName?.split('.')[1],
          type: "number",
          drillMembers: [],
          drillMembersGrouped: {
            measures: [],
            dimensions: []
          }
        };
      } else { // dimension
        annotation.dimensions[field.fieldName] = {
          title: field?.displayName || field?.fieldName,
          shortTitle: field?.displayName || field?.fieldName?.split('.')[1],
          description: field?.displayName || field?.fieldName?.split('.')[1],
          type: "string"
        };
      }
    });

    return annotation;
}

export const resultSetWrapper = ({mergeReport, resultSet, combinedData}) => {
    const mergeReportConfig = (mergeReport && mergeReport?.length>0) ? mergeReport[mergeReport?.length - 1] : []
    const {measures, dimensions} = createMergeReportQueries(mergeReportConfig);
    const combinedAnnotations = createMergeReportAnnotations(mergeReportConfig);

    let resultNew = resultSet.loadResponses
    resultNew[0].data = combinedData
    resultNew[0].query = {...resultSet.loadResponses[0].query, measures, dimensions}
    resultNew[0].annotation = combinedAnnotations

    let loadResponseNew = resultSet.loadResponse
    loadResponseNew.results = resultNew
    loadResponseNew.pivotQuery = {...resultSet.loadResponse.pivotQuery, measures, dimensions}

    resultSet.loadResponse = loadResponseNew
    resultSet.loadResponses = resultNew
    return resultSet
}
